export const getDetail = ( state ) => {
    return state.detail
}

export const getFavorites = ( state ) => {
    return state.favorites
}
